module.exports = __webpack_public_path__ + "img/productpage_icon_ig.b4e931fa.png";